<div [id]="chartdiv_id" class = 'barLineChart'></div>
